import { ICommonLink } from '@src/models/common';

export const USER_SETTINGS: ICommonLink = {
  id: 'userSettingsLink',
  href: '/profile/settings',
  name: 'Настройки',
  icon: 'settings',
  tags: ['allUsers'],
};

export const USER_TEAM: ICommonLink = {
  id: 'userTeamLink',
  href: '/profile/team',
  name: 'Команда',
  icon: 'team',
  tags: ['role.client-primary-manager', 'role.agency-primary-manager'],
};

export const USER_PROFILE: ICommonLink = {
  id: 'userProfileLink',
  href: '/profile',
  name: 'Профиль',
  exact: true,
  tags: ['allUsers'],
  icon: 'profile',
};

export const USER_COMPANY: ICommonLink = {
  id: 'userCompanyLink',
  href: '/profile/company',
  name: 'Моя компания',
  icon: 'company',
  tags: ['role.client-manager', 'role.client-primary-manager', 'role.agency-manager', 'role.agency-primary-manager'],
};

export const USER_TARIFF: ICommonLink = {
  id: 'userTariffLink',
  href: '/profile/tariff',
  name: 'Мой тариф',
  icon: 'finances',
  tags: ['role.client-manager', 'role.client-primary-manager', 'role.agency-manager', 'role.agency-primary-manager'],
};
